import { DEFAULT_PAGINATION_QUERY } from 'app/components/Table/core/constants';
import { QueryState } from 'app/components/Table/core/types';

import {
  MailHistoryFilterParams,
  MailTrackingRecipientType,
  MailType,
} from 'app/modules/mail-history/core/types';

import { OrganizationInfo } from 'theme/layout/components/aside/store';

export const BADGE_MAP: Record<MailType, { variant: string; textColor: string }> = {
  [MailType.ABNORMAL_CONNECTION]: {
    variant: 'info',
    textColor: '#fff',
  },
  [MailType.FAILED_CONNECTION]: {
    variant: 'danger',
    textColor: '#fff',
  },
  [MailType.REACH_PAR_ALARM_LEVEL]: {
    variant: 'warning',
    textColor: '#000',
  },
  [MailType.REACH_CRITICAL_LEVEL]: {
    variant: 'primary',
    textColor: '#fff',
  },
  [MailType.SHELF_EXPIRY]: {
    variant: 'secondary',
    textColor: '#000',
  },
  [MailType.EXPIRY_CV]: {
    variant: 'success',
    textColor: '#fff',
  },
};

export const MAIL_TYPE_LABELS: Record<MailType, string> = {
  [MailType.ABNORMAL_CONNECTION]: 'Abnormal Consumption',
  [MailType.FAILED_CONNECTION]: 'Failed Connection',
  [MailType.REACH_PAR_ALARM_LEVEL]: 'Reach Par Alarm Level',
  [MailType.REACH_CRITICAL_LEVEL]: 'Reach Critical Level',
  [MailType.SHELF_EXPIRY]: 'Shelf Expiry',
  [MailType.EXPIRY_CV]: 'Realtime Expiry',
};

export const DEFAULT_MAIL_TRACKING_TABLE_QUERY: QueryState = {
  ...DEFAULT_PAGINATION_QUERY,
  orderBy: 'mail_tracking.sent_at',
  orderDirection: 'DESC',
};

export const DEFAULT_MAIL_HISTORY_FILTER: MailHistoryFilterParams = {
  organizationId: [],
  recipientType: [],
  type: [],
  page: 1,
};

export const ORGANIZATION_OPTIONS = (organizations: OrganizationInfo[]) =>
  organizations.map((el) => ({
    ...el,
    label: el.name,
    value: String(el.id),
  }));

export const SELECTED_ORGANIZATION = (
  organizationIds: string[],
  organizations: OrganizationInfo[],
) =>
  organizationIds.map((el) => {
    const organization = organizations.find((o) => String(o.id) === el);

    return {
      value: el,
      label: organization ? organization.name : '',
    };
  });

export const TYPE_OPTIONS = Object.values(MailType).map((el) => ({
  label: MAIL_TYPE_LABELS[el],
  value: el,
}));

export const SELECTED_TYPE = (typeIds: string[]) =>
  typeIds.map((el) => {
    const type =
      MAIL_TYPE_LABELS[Object.values(MailType).find((t) => String(t) === el) as MailType];

    return {
      label: type,
      value: el,
    };
  });

export const RECIPIENT_TYPE_OPTIONS = [
  { label: 'System Admin', value: String(MailTrackingRecipientType.SYSTEM_ADMIN) },
  { label: 'Organization Admin', value: String(MailTrackingRecipientType.ORGANIZATION_ADMIN) },
];

export const SELECTED_RECIPIENT_TYPE = (recipientTypeIds: string[]) =>
  recipientTypeIds.map((el) => {
    const recipientType =
      el === String(MailTrackingRecipientType.SYSTEM_ADMIN) ? 'System Admin' : 'Organization Admin';

    return {
      label: recipientType,
      value: el,
    };
  });

export const BASE_WEIGHT_INITIAL_VALUES = (baseWeight: number) => ({
  currentBaseWeight: baseWeight,
  newBaseWeight: null,
});
